var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Pane, Row, Col, AccordionSet, Accordion, PaneFooter, ErrorModal, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RecekTextField, RecekSelection } from "../../components/inputs";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createPublisherPrefixSchema } from "../../utils/validationUtils";
import { useModal } from "../../utils/useModal";
import { FormFooterStart } from "../../components/FormFooterStart";
import { FormFooterEnd } from "../../components/FormFooterEnd";
import { searchAgencyPublishers } from "../../api/publisherService";
import { useScrollToError } from "../../hooks/useScrollToError";
import { formatPublisherLabel } from "../../utils/formatPublisherLabel";
import { getErrorCode } from "../../utils/getErrorCode";
import { ErrorType } from "../../types/ErrorType";
var transferErrorMessageIds = (_a = {},
    _a[ErrorType.CANNOT_TRANSFER_INACTIVE_PREFIX] = "ui-br-agency.publisher-prefix.transfer.error.inactivePrefix",
    _a[ErrorType.CANNOT_TRANSFER_PREFIX_TO_CLOSED_PUBLISHER] = "ui-br-agency.publisher-prefix.transfer.error.closedPublisher",
    _a[ErrorType.CANNOT_TRANSFER_PREFIX_TO_SAME_PUBLISHER] = "ui-br-agency.publisher-prefix.transfer.error.samePublisher",
    _a);
var PublisherPrefixForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title;
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var ky = useOkapiKy();
    var _b = useModal(), isOpen = _b.isOpen, message = _b.message, openModal = _b.openModal, closeModal = _b.closeModal;
    var _c = useState([]), publisherOptions = _c[0], setPublisherOptions = _c[1];
    var _d = useForm({
        resolver: zodResolver(createPublisherPrefixSchema(formatMessage)),
        defaultValues: initialValues,
        mode: "onBlur",
    }), handleSubmit = _d.handleSubmit, control = _d.control, reset = _d.reset, errors = _d.formState.errors;
    useEffect(function () {
        reset(initialValues);
    }, [initialValues, reset]);
    useScrollToError(errors);
    useEffect(function () {
        var _a;
        if ((_a = initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher) === null || _a === void 0 ? void 0 : _a.id) {
            setPublisherOptions([
                {
                    value: initialValues.publisher.id,
                    label: formatPublisherLabel(initialValues.publisher, formatMessage) ||
                        initialValues.publisher.id,
                },
            ]);
        }
    }, [initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher, formatMessage]);
    var handlePublisherFilter = useCallback(function (filterValue) { return __awaiter(void 0, void 0, void 0, function () {
        var query, result, options, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!filterValue || filterValue.length < 2) {
                        setPublisherOptions([]);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    query = "(name==\"*".concat(filterValue, "*\" or nameSuffix==\"*").concat(filterValue, "*\" or qualifier==\"*").concat(filterValue, "*\") and status==\"ACTIVE\"");
                    return [4 /*yield*/, searchAgencyPublishers(ky, {
                            query: query,
                            limit: 100,
                        })];
                case 2:
                    result = _b.sent();
                    options = ((_a = result.items) === null || _a === void 0 ? void 0 : _a.filter(function (publisher) { return publisher.id; }).map(function (publisher) { return ({
                        value: publisher.id,
                        label: formatPublisherLabel(publisher, formatMessage) || publisher.id,
                    }); })) || [];
                    setPublisherOptions(options);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error("Error filtering publishers:", error_1);
                    setPublisherOptions([]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [ky, formatMessage]);
    var handlePublisherChange = useCallback(function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
        var result, publisher, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!publisherId) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, searchAgencyPublishers(ky, {
                            query: "id==\"".concat(publisherId, "\""),
                            limit: 1,
                        })];
                case 2:
                    result = _b.sent();
                    publisher = (_a = result.items) === null || _a === void 0 ? void 0 : _a[0];
                    if (publisher) {
                        reset(__assign(__assign({}, initialValues), { publisher: {
                                id: publisher.id,
                                name: publisher.name,
                            } }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.error("Error fetching publisher:", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [ky, initialValues, reset]);
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3, errorCode, messageId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    return [4 /*yield*/, getErrorCode(error_3)];
                case 3:
                    errorCode = _a.sent();
                    messageId = (errorCode && transferErrorMessageIds[errorCode]) ||
                        "ui-br-agency.publisher-prefix.transfer.error.generic";
                    openModal(formatMessage({ id: messageId }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-agency.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: function () {
                        return navigation.publisherPrefixes &&
                            history.push(navigation.publisherPrefixes.path);
                    }, buttonMessageId: "ui-br-agency.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: isOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: message, onClose: closeModal }),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(function (data) {
                    return handleFormSubmit(__assign(__assign({}, initialValues), data));
                }) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { id: "publisherPrefixBasic", label: formatMessage({
                            id: "ui-br-agency.publisher-prefix.form.section.basic",
                        }), open: true },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "value", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { disabled: true, labelId: "ui-br-agency.publisher-prefix.value.field.label", error: (_b = errors.value) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })))),
                    React.createElement(Accordion, { id: "publisherPrefixRelations", label: formatMessage({
                            id: "ui-br-agency.publisher-prefix.form.section.relations",
                        }), open: true },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "publisher", render: function (_a) {
                                        var _b, _c, _d, _e, _f;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, __assign({}, field, { labelId: "ui-br-agency.publisher-prefix.publisher.field.label", dataOptions: publisherOptions, asyncFilter: true, onFilter: handlePublisherFilter, value: (_c = (_b = field.value) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "", onChange: handlePublisherChange, error: ((_e = (_d = errors.publisher) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.message) ||
                                                ((_f = errors.publisher) === null || _f === void 0 ? void 0 : _f.message), required: true })));
                                    } })))))))));
};
export default PublisherPrefixForm;
